module.exports = __webpack_public_path__ + "files/a4760fcda78bcc9bf56890980f1c4b51.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/nature.png
// module id = 585
// module chunks = 59